import "./Facilities.css";
import { IoCheckmarkCircleOutline, IoEaselOutline, IoShieldCheckmarkOutline } from "react-icons/io5";
import { FacilitiesData } from "./FacilitiesData";
import { IoSnowOutline } from "react-icons/io5";
import { HiOutlineUsers } from "react-icons/hi2";


export default function Facilities() {
    return (
        <div className="landing-pages">
            <section className="recent-events">
                <p className="founder-subtitle">— Our Signature</p>
                <h2 className="founder-title">
                    <span>Learning</span> Studios
                </h2>
                <p className="event-desc">
                    At The Kindergarten International, our thoughtfully designed learning studios inspire curiosity, creativity, confidence and a love for learning in every child.
                </p>
                <div className="facilities-box">
                    {FacilitiesData.map((item) => (
                        <div
                            className="facilities-card"
                            key={item.id}
                            style={{ background: item.color }}
                        >
                            <div className="fac-card-top">
                                <img src={item.logo} alt="" className="fac-logo" />
                            </div>

                            <div className="fac-content">
                                <div className="fac-top-heading">
                                    <h3 style={{ color: item.color }}>{item.title}</h3>
                                    <p className="subtitle" style={{ color: item.color }}>{item.subtitle}</p>
                                </div>
                                <img src={item.image} alt={item.title} className="fac-image" />

                                <div className="fac-item-box">
                                    <div className="fac-item-left" style={{ background: item.color }}>
                                        {item.points.map((point, index) => (
                                            <div className="point" key={index}>
                                                <div className="fac-item-left-icon">
                                                    <IoCheckmarkCircleOutline style={{ color: item.color }} />
                                                </div>
                                                <span>{point}</span>
                                            </div>
                                        ))}
                                    </div>

                                    <div className="fac-item-right">
                                        <p>{item.description}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="fac-feture-box">
                    <div className="fac-feture-box-item">
                        <div className="fac-feture-item">
                            <span><IoSnowOutline /></span>
                            <p>Fully Air-Conditioned</p>
                        </div>
                        <div className="fac-feture-item">
                            <span><IoEaselOutline /></span>
                            <p>Smart Boards & Projectors</p>
                        </div>
                        <div className="fac-feture-item">
                            <span><IoShieldCheckmarkOutline /></span>
                            <p>Safe & Secure Environment</p>
                        </div>
                        <div className="fac-feture-item">
                            <span><HiOutlineUsers /></span>
                            <p>Child-Friendly Learning Spaces</p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}
